/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

import '../assets/css/style.css'
import koukoumade from '../assets/img/kyouiku/image_1.svg'
import daigaku from '../assets/img/kyouiku/image_2.svg'
import daigakumade from '../assets/img/kyouiku/image_3.svg'
import titleKyouiku from '../assets/img/title/title_kyouiku.svg'
import { Link } from 'react-router-dom'
import { Header } from '../components/header'
import { Footer } from '../components/footer'
import { useHeadTitle } from '../hook/useHeadTitle'
import { useDealerCodeUrl } from '../hook/useDealerCode'
import { useDescription } from '../hook/useDescription'

export default function Kyouiku() {
  useHeadTitle('今こそ資産運用を考えよう', '教育資金')
  useDescription(
    '資産運用について知っておきたい基本とコツ。野村アセットマネジメントが資産運用に取り組む皆さまをサポートします。'
  )
  return (
    <React.Fragment>
      <Header />
      <main>
        <section>
          <div className="c-title-wrap">
            <h2 className="c-title--primary">
              <span className="c-title__balloon">
                <span>どのくらい準備する？</span>
              </span>
              <img src={titleKyouiku} alt="教育資金" />
            </h2>
            <p className="c-title__lead">
              子供の成長は何よりうれしいものです。
              <br />
              ただし教育にかかる費用は決して少なくありません。
            </p>
          </div>

          <div className="l-container">
            <div className="u-pt34px">
              <section className="c-box">
                <h3 className="c-box__head">
                  <span className="c-box__head__title">子ども１人にかかる教育費はどれくらい？</span>
                </h3>
                <div className="p-kyouiku__box-body">
                  <p className="p-kyouiku__lead--primary">
                    お子様の人数によっては、2倍、3倍とかかることも。計画的に準備をしていくことが大切です。
                  </p>
                  <section>
                    <h4 className="c-heading-1 u-mt24px">幼稚園から高校までにかかる費用</h4>
                    <p className="u-text--center">
                      <img src={koukoumade} alt="幼稚園から高校までにかかる費用" />
                    </p>
                  </section>
                  <section>
                    <h4 className="c-heading-1 u-mt66px">大学にかかる費用</h4>
                    <p className="u-text--center">
                      <img src={daigaku} alt="大学にかかる費用" />
                    </p>
                    <p className="p-kyouiku__note u-mt10px">
                      私立大学、短大は施設設備費を含む。2年目以降の費用は、初年度の入学料以外がそのまま続くとして4年間、短大が2年間で試算。生活費は含まず。
                      <br />
                      （出所）文部科学省「令和3年度子供の学習費調査」（
                      <a href="https://www.mext.go.jp/" target="_blank" rel="noopener noreferrer">
                        https://www.mext.go.jp/
                      </a>
                      ）等を基に野村アセットマネジメント作成
                      <br />
                      注：図表の数字は、四捨五入している場合があります。
                    </p>
                  </section>
                  <section>
                    <h4 className="c-heading-1 u-mt69px">幼稚園から大学までの一人あたり教育費</h4>
                    <p className="u-text--center">
                      <img
                        src={daigakumade}
                        alt="幼稚園から大学までの一人あたり教育費"
                        className="img-2box"
                      />
                    </p>
                    <p className="p-kyouiku__note u-mt6px">
                      ※幼稚園～高校：学習塾などの学校外活動含む。幼稚園は3年間。大学：私立大学は施設設備費を含む。
                      2年目以降の費用は、初年度の入学料以外がそのまま続くとして4年間で試算。
                    </p>
                  </section>
                </div>
              </section>
            </div>

            <p className="p-kyouiku__lead--secondary u-mt70px">
              お客様の目標金額はどのくらいでしょうか？
            </p>
            <div className="p-kyouiku__button">
              <Link
                to={useDealerCodeUrl('/calc')}
                className="c-button--secondary c-button-arrow--next"
              >
                <span className="c-button__text--m u-mr24px">つみたてシミュレーションはこちら</span>
              </Link>
            </div>
          </div>
        </section>

        <div className="u-bg--white u-mt60px">
          <div className="c-button-group">
            <Link to={useDealerCodeUrl('/')} className="c-button--primary c-button-arrow--back">
              <span className="c-button__text--xs">TOPページへ戻る</span>
            </Link>
            <Link
              to={useDealerCodeUrl('/toushin')}
              className="c-button--primary c-button-arrow--next"
            >
              <span className="c-button__text--xs u-mr10px">投資信託とはへ進む</span>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </React.Fragment>
  )
}
